import ApplicationPaymentsLoading from "../components/loaders/ApplicationPaymentsLoading";
import ApplicationPaymentComponent from "../components/applicationPayment/ApplicationPayment";
import { useApplication } from "../hooks/useApplication";
import { useUser } from "../hooks/useUser";

const Page = (props) => {
  const application = useApplication();
  const user = useUser();

  if (!application || !user) {
    return <ApplicationPaymentsLoading />;
  }

  return <ApplicationPaymentComponent {...props} />;
};

export default Page;
